import config from "./../../../config/common";
import clamp from "lodash/clamp";

export const extendOffsetLowerBound = state => ({
  ...state.offset,
  lower: clamp(
    state.offset.lower - config.api.product.search.pageSize,
    0,
    state.offset.upper
  )
});

export const extendOffsetUpperBound = (state, payload) => ({
  ...state.offset,
  upper: clamp(
    state.offset.upper + config.api.product.search.pageSize,
    state.offset.lower,
    payload.itemCount
  )
});

const getLowerOffsetFromQuery = (state, payload) => {
  const lowerOffset = (state.query && parseInt(state.query.offset, 10)) || 0;

  return clamp(lowerOffset, 0, payload.itemCount);
};

export const getOffsetFromQuery = (state, payload) => {
  const lowerOffset = getLowerOffsetFromQuery(state, payload);
  const offset = {
    initial: lowerOffset,
    lower: lowerOffset,
    upper: lowerOffset
  };

  return extendOffsetUpperBound({ offset }, payload);
};
